import * as PaymentMethods from './PaymentMethods';
import * as Workflow from './WorkflowTypes';
import { getEndOfDay, getPastXDays } from "../util/DateUtility";
import { format } from 'date-fns';

export const StatusFilterTypes = [
    { label: 'All', value: 'all' },
    { label: 'Open', value: 'open' },
    { label: 'Processing', value: 'processing' },
    { label: 'Reconciled', value: 'reconciled' },
    { label: 'Closed', value: 'closed' }
];

export const PaymentMethodFilterTypes = [
    { label: 'All', value: 'all' },
    { label: 'Check', value: PaymentMethods.CHECK },
    { label: 'Direct Deposit', value: PaymentMethods.DIRECT_DEPOSIT },
    { label: 'eCheck', value: PaymentMethods.ECHECK },
    { label: 'Deposit to Debit Card', value: PaymentMethods.PUSH_TO_DEBIT },
    { label: 'Virtual Credit Card', value: PaymentMethods.VIRTUAL_CARD },
    { label: 'Not Selected', value: '' }
];

export const VendorPaymentMethodFilterTypes = [
    { label: 'All', value: 'all' },
    { label: 'Check', value: PaymentMethods.CHECK },
    { label: 'Direct Deposit', value: PaymentMethods.DIRECT_DEPOSIT },
    { label: 'Virtual Credit Card', value: PaymentMethods.VIRTUAL_CARD },
    { label: 'Not Selected', value: '' }
];

export const DateFilterTypes = [
    { label: 'Last 30 Days', value: 'last30days' },
    { label: 'Last 60 Days', value: 'last60days' },
    { label: 'Last 90 Days', value: 'last90days' },
    { label: 'Last 12 Months', value: 'last365days' },
    { label: 'Custom Date Range', value: 'custom-date-range' }
];

export const PaymentTrendsDateFilterTypes = [
    { label: 'Previous 7 Days', value: 'last7days' },
    { label: 'Last 30 Days', value: 'last30days' },
    { label: 'Last 60 Days', value: 'last60days' },
    { label: 'Last 90 Days', value: 'last90days' },
    { label: 'Custom Date Range', value: 'custom-date-range' }
];

export const PaymentTrendsPaymentTypes = [
    { label: 'All', value: 'ALL' },
    { label: 'Single Party', value: Workflow.SINGLE_PARTY },
    { label: 'Multi-Party', value: Workflow.MULTI_PARTY },
    { label: 'Vendor', value: Workflow.VENDOR }
];

export const DefaultAdvancedSearchOptions = [
    { value: 'paymentNumber', label: 'Payment Number', maxLength: 50 },
    { value: 'partyName', label: 'Party Name', maxLength: 50 },
    { value: 'disbursementUuid', label: 'Disbursement UUID', maxLength: 50 },
];

export const VendorAdvancedSearchOptions = [
    { value: 'paymentNumber', label: 'Payment Number', maxLength: 50 },
    { value: 'partyName', label: 'Vendor Name', maxLength: 50 },
    { value: 'disbursementUuid', label: 'Disbursement UUID', maxLength: 50 },
    { value: 'vendorCode', label: 'Vendor ID', maxLength: 50 },
];

export const getSelectedOptionsFromValues = (allOptions, values) => {
    if (!values || values.length === 0 || values.length > allOptions.length - 2) {
        // All options
        return allOptions;
    }

    const whereHasMatchingValue = (option) => {
        for (let i = 0; i < values.length; i++) {
            if (option.value === values[i]) {
                return true;
            }
        }
        return false;
    };

    return allOptions.filter(whereHasMatchingValue);
};

export const getDateFilterOptionsFromValues = (startDate, endDate) => {
    if (!startDate || !endDate) {
        return null;
    }

    // Use formatted dates for comparison, as strict equality will not give expected results
    const d = (date) => format(date, 'yyyy-MM-dd');
    startDate = d(startDate);
    endDate = d(endDate);

    if (endDate !== d(getEndOfDay())) {
        // Custom endOn date means custom range
        return DateFilterTypes[4];
    }
    
    let year = d(getPastXDays(365).startOn); // Last 12 Months
    if (startDate === year) {
        return DateFilterTypes[3];
    }
    
    let past30 = d(getPastXDays(30).startOn); // 30 days
    if (startDate === past30) {
        return DateFilterTypes[0];
    }
    
    let past60 = d(getPastXDays(60).startOn); // 60 days
    if (startDate === past60) {
        return DateFilterTypes[1];
    }
    
    let past90 = d(getPastXDays(90).startOn); // 90 days
    if (startDate === past90) {
        return DateFilterTypes[2];
    }

    // Default to custom date
    return DateFilterTypes[4];
};